// @flow
import React from "react";
import ReactDOM from "react-dom";

import type {SourceType} from "./constants";
// import ApVideoHubPortFull from "./ApVideoHubPortFull";
// import ApVideoHubPortFull from "./ApVideoPlayerStandalone";
import ApVideoHubPortFull from "./ApVideoPlayerNew";

type OptionsSingle = {|
    root: string | HTMLDivElement;
    type: SourceType;
|}

type Options = OptionsSingle | Array<OptionsSingle>;

const ApVideoPlayer = {
    create(options: Options) {
        this._validate(options);
        if (Array.isArray(options)) {
            options.forEach(optionItem => {
                ReactDOM.render(<ApVideoHubPortFull onDispose={this.dispose} {...optionItem}/>, this._getRoot(optionItem));
            });
        } else {
            ReactDOM.render(<ApVideoHubPortFull onDispose={this.dispose} {...options}/>, this._getRoot(options));
        }
    },
    dispose(root: string | HTMLDivElement) {
        ReactDOM.unmountComponentAtNode(this._getRoot({root}));
    },
    //todo: проверять что переданный элемент правильного типа
    _validate(options: Options) {
        if (Array.isArray(options)) {
            options.forEach(optionItem => this._validate(optionItem));
        } else {
            const {root} = options;
            if (!root) {
                throw new Error("You should specify root as id or a node");
            } else {
                if (typeof root === "string" && !document.getElementById(root)) throw new Error(`Can't find element with id "${root}" provided as root`);
                if (typeof root === "object" && !document.body.contains(root)) throw new Error(`Can't find DOM node "${root}" provided as root`);
            }
        }
    },
    _getRoot(options: Options): HTMLDivElement {
        const {root} = options;
        if (typeof root === "string") return document.getElementById(root);
        if (typeof root === "object") return root;
    }
}

export default ApVideoPlayer;